import { render, staticRenderFns } from "./ChatVoice.vue?vue&type=template&id=a7096470"
import script from "./ChatVoice.vue?vue&type=script&lang=js"
export * from "./ChatVoice.vue?vue&type=script&lang=js"
import style0 from "./ChatVoice.vue?vue&type=style&index=0&id=a7096470&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.38_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_lhktxyxuicyh6fb6yjjvusexfi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports